export default "__VITE_PUBLIC_ASSET__11b7d911__"